import StoreCommon from "@/services/StoreCommon"

export default class PostStoreCommon {
    static handle(obj) {
        StoreCommon.set("post", obj)
    }
}
